import { render, staticRenderFns } from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=template&id=413d479a&scoped=true"
import script from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=script&lang=js"
export * from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=script&lang=js"
import style0 from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=style&index=0&id=413d479a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d479a",
  null
  
)

export default component.exports